import { render, staticRenderFns } from "./agen-naik-kelas-progress-modal.vue?vue&type=template&id=5ebde502&scoped=true"
import script from "./agen-naik-kelas-progress-modal.vue?vue&type=script&lang=js"
export * from "./agen-naik-kelas-progress-modal.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/components/agen-naik-kelas-progress-modal.scss?vue&type=style&index=0&id=5ebde502&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebde502",
  null
  
)

export default component.exports